import TechnicalAnalysisPage from './TechnicalAnalysisPage';

export default TechnicalAnalysisPage;
